// extracted by mini-css-extract-plugin
export var actionButton = "_kn-t";
export var buttonContainer = "_kn-0";
export var buttonContainer2 = "_kn-1";
export var buttonSection = "_kn-2";
export var details = "_kn-3";
export var dropdownItem = "_kn-5";
export var dropdownItemsContainer = "_kn-4";
export var fileInput = "_kn-r";
export var headerButton = "_kn-6";
export var icon = "_kn-7";
export var input = "_kn-8";
export var macroListItem = "_kn-9";
export var mainContent = "_kn-a";
export var microText = "_kn-b";
export var modal = "_kn-w";
export var optionsButton = "_kn-c";
export var paperclip = "_kn-s";
export var pillContent = "_kn-d";
export var preview = "_kn-e";
export var preview2 = "_kn-f";
export var quillEditor = "_kn-q";
export var selectedMacro = "_kn-g";
export var sidebar = "_kn-h";
export var sidebarHeader = "_kn-j";
export var sidebarList = "_kn-i";
export var sidebarListItem = "_kn-k";
export var sidebarSearch = "_kn-l";
export var snoozeDurationWrapper = "_kn-v";
export var statusPillContainer = "_kn-m";
export var tagsContainer = "_kn-n";
export var unselectedMacro = "_kn-o";
export var variable = "_kn-u";
export var wrapper = "_kn-p";